export const MAX_CREATE_WITH_IA_REFERENCE_IMAGES = 3;
export const MAX_CREATE_WITH_IA_REFERENCE_IMAGES_VIDEO = 3;

export const getCreateWithIAReferenceImageLimit = ({ mediaType }) => {
  const resolved = mediaType === "carousel" ? "image" : mediaType;
  return resolved === "video"
    ? MAX_CREATE_WITH_IA_REFERENCE_IMAGES_VIDEO
    : MAX_CREATE_WITH_IA_REFERENCE_IMAGES;
};

export const mergeReferenceImageUrls = ({
  currentUrls = [],
  newUrls = [],
  mediaType,
  max,
}) => {
  const limit =
    max ??
    getCreateWithIAReferenceImageLimit({
      mediaType: mediaType ?? "image",
    });
  const availableSlots = Math.max(0, limit - currentUrls.length);
  const limitedNew = newUrls.filter(Boolean).slice(0, availableSlots);
  return [...limitedNew, ...currentUrls].slice(0, limit);
};

export const getRemainingReferenceImageSlots = ({
  currentCount = 0,
  mediaType,
  max,
}) => {
  const limit =
    max ??
    getCreateWithIAReferenceImageLimit({
      mediaType: mediaType ?? "image",
    });
  return Math.max(0, limit - currentCount);
};

export const limitReferenceImageUrls = ({ imagesUrl, mediaType }) => {
  if (!Array.isArray(imagesUrl)) {
    return [];
  }
  const limit = getCreateWithIAReferenceImageLimit({ mediaType });
  return imagesUrl.filter(Boolean).slice(0, limit);
};
